module.exports = __webpack_public_path__ + "static/media/Teen Patti Muflis.f72339b7.jpg";